export const projectData2021 = [
  {
    name: '绿色环保防水防油纸浆模塑的开发',
    organization: ['广州荧创科技有限公司', '杭州西红柿环保科技有限公司', '华南理工大学制浆造纸工程国家重点实验室'],
    introduction: [
      '项目以天然生物质基蜡质、天然脂肪酸等作为低表面能改性物质，以来源于植物的半纤维素衍生物作为乳化剂，开发了系列全生物质基防水涂层。还采用了喷涂工艺结合干法模塑工艺制造防水防油纸浆模塑，显著降低涂层助剂的用量，缩短工艺制造流程，减少用水量和污水排放，降低干燥耗能。',
      '项目将建成50吨/年全生物基防水防油乳液生产线和3000吨/年干法模塑生产线。',
    ],
    reason: ['项目将率先产业化应用新型全生物基可食品接触的防水防油涂层技术，该材料可替代传统的含氟防水防油剂；结合节能减排的干法成型制造工艺生产新一代防水防油纸浆模塑外卖餐盒，相比高能耗传统湿法成型工艺提升生产效率近66%，显著降低能源消耗量，实现项目低碳减排。'],
    imgurl: 'https://img.meituan.net/gongyimobile/8a03ddedbab43ca4b57016f6ea4583b2116635.jpg',
    year: '2021',
  },
  {
    name: '绿色包装原材料PHA千吨生产示范线建设',
    organization: ['北京微构工场生物技术有限公司'],
    introduction: [
      '项目采用了"下一代工业生物技术(NGIB)"的底盘菌种—嗜盐单胞菌Halomonas作为生产菌种进行发酵生产。Halomonas TD在高碱性培养条件下细胞生长迅速、PHA合成积累占比高，能快速成为体系中的优势菌株，具备不怕染菌的特性；还采用了一种高纯度PHA的水相提取方法，具有条件温和、成本低、污染小等优点，获得的产品纯度、回收率高，适合下游市场更全面的应用产业化生产。',
      '项目将建成年产1000吨/年PHA原材料生产线。',
    ],
    reason: [
      'PHA作为全生物降解材料，相较其它可降解塑料拥有高防水性、热稳定性好、自然可降解性（可在海水中降解）方面的优势，但因受限于成本，在包装场景应用一直尚待开发。通过利用低成本碳源（如餐厨垃圾）、生产流程优化等技术，实现了PHA工业发酵的无灭菌、连续化生产，使PHA原料成本降低30%以上，并突破性地将PHA材料应用于一次性吸管和一次性餐盒等外卖包装场景。',
    ],
    imgurl: 'https://img.meituan.net/gongyimobile/7b52c32392d018cd19f5082087d2e5a0870901.jpg',
    year: '2021',
  },
  {
    name: '全生物降解绿色创新外卖包装专用料制备与应用',
    organization: ['珠海金发生物材料有限公司'],
    introduction: [
      '项目（1）利用多元协同增效淀粉塑化技术和一步法反应共混挤出技术，开发高生物基低成本耐湿提携袋专用料；（2）利用多官能团相容剂调节聚合物结晶，开发高透明性可食品接触打包袋专用料；（3）利用多官能团相容剂改善多相界面相容性及合金化技术，开发耐高温薄壁注塑餐盒专用料；（4）利用基础树脂规格筛选配型提升加工性能并通过增韧提升熔体强度，开发宽耐温易成型吸塑杯碗专用料。',
      '项目将技改建成年产3000吨-5000吨可降解外卖包装专用料生产线。',
    ],
    reason: [
      '传统生物降解材料因强度差、透明度低和不耐高温等原因无法广泛应用于餐饮外卖包装。本项目在全生物降解绿色创新外卖包装专用料开发过程中，针对不同应用场景的特性需求，分别应用多种创新技术，通过配方、工艺设计和食品接触迁移模拟实验筛选技术确保食品接触材料的安全性和可靠性，预期成果具有较好的应用前景。',
    ],
    imgurl: 'https://img.meituan.net/gongyimobile/10e7235195ff0dddef5f0836dedc8a0f3623055.jpg',
    year: '2021',
  },
  {
    name: '蔗渣模塑绿色生产工艺研发及示范',
    organization: ['广西博冠环保制品有限公司', '华南理工大学', '珠海格力智能装备有限公司'],
    introduction: [
      '项目基于预浸渍技术对蔗渣纤维微观组分的作用机制，对生物预处理技术、化学预浸渍技术及机械处理技术的作用进行协同耦合，改善纤维原料的润胀、软化效果，减少挤压疏解和磨浆过程中对纤维的强行撕裂，降低纤维束的残留率。最终形成生产原料适应性强，成浆性能良好，污染负荷小的高效生物蔗渣浆的优化生产工艺。另外，通过设备的优化，降低电机能耗，提升生产效率，实现模具高效合模。',
      '项目将建成产能为200吨/年生物模塑纸浆中试生产线，完成5万吨/年蔗渣模塑用浆清洁生产线提质改造。',
    ],
    reason: [
      '甘蔗渣纸浆采用传统的化学制浆法一般存在得率低、环保治理成本较高，而机械法和化学机械法制浆纤维强度较差。本项目开发适于蔗渣纤维原料清洁生物制浆新技术，实现高得率、低能耗的纸浆生产关键工艺和装备国产化，围绕植物资源循环利用、植物固废资源化、塑料污染治理等领域的重大需求，开展废弃植物纤维资源绿色转化工艺技术落地与工程应用示范。',
    ],
    imgurl: 'https://img.meituan.net/gongyimobile/1f02c96eed2036c01da92018366015a3937137.jpg',
    year: '2021',
  },
  {
    name: '微/纳米纤维素基多功能食品包装纸',
    organization: ['济南圣泉集团股份有限公司'],
    introduction: [
      '项目以植物纤维素为原料，利用自主研发的生物质精炼"三素分离技术"制备出纳米纤维素，并通过对纳米纤维素的改性、浆内添加工艺和表面纸张涂布工艺，在满足食品包装纸相关产品安全标准等技术要求，赋予纸张高强、防水、阻隔、防油等性能。',
      '项目将交付1550吨功能性食品包装纸产能，并满足相关产品标准。',
    ],
    reason: ['项目以植物秸秆为原料，通过纳米纤维素工业化制备及改性，使纤维素的食品包装应用具有增强、防水、防油等性能，应用于防水、防油食品包装纸等外卖应用场景，有效解决了PE淋膜纸板包装材料无法降解且无法再浆的问题。该项目也是实现农业植物秸秆的应用的可行绿色推广技术之一。'],
    imgurl: 'https://img.meituan.net/gongyimobile/347fe906355423d541cf443944e4891a8429211.jpg',
    year: '2021',
  },
  {
    name: '餐盒高值回收再生创新技术工艺方案',
    organization: ['上海睿聚环保科技有限公司'],
    introduction: [
      '项目针对餐盒再生塑料黑点多、气味重、稳定性差等行业痛点，通过热洗设备的创新改进，最大程度去除物料表面的油污。同时采用蒸汽热洗的形式减少清洗液和水的使用，降低污水处理压力；结合开发的自动化废水循环系统，相比传统清洗方案节约至少40%的用水。工艺还采用定制化挤出机和过滤器的组建的设计使用，提升过网目数，有效减少粒子黑点；通过真空室等设计，有效去除挥发性物质，降低产品气味。',
      '项目将回收餐盒2430吨/年，建成年处理量5000吨的高品质PP再生颗粒生产线。',
    ],
    reason: [
      '项目采用创新的塑料餐盒高值化回收再生处理工艺，将突破传统再生塑料黑点多、气味重、稳定性差等问题，通过一系列的工艺改进和技术创新，向市场提供高品质再生 PP 餐盒塑料颗粒，并将其应用扩展至日化包装等高端市场。该项目将成为再生塑料行业标杆，引领产业向自动化、数字化、高值化、高质化方向升级转型，树立绿色低碳新理念，助力行业减碳新目标。',
    ],
    imgurl: 'https://img.meituan.net/gongyimobile/2b57c961174d2de2a73937a14a9c13cc83161.jpg',
    year: '2021',
  },
  {
    name: '回收聚丙烯餐盒的高值化应用',
    organization: ['东华大学', '江西格林循环产业股份有限公司', '广东蒙泰高新纤维股份有限公司', '李宁（中国）体育用品有限公司', '翠丰（上海）采购咨询有限公司'],
    introduction: [
      '项目开发了塑料餐盒制备细旦聚丙烯纤维和高强度聚丙烯纤维的关键技术，并实现其在高档运动服装、背包及安全绳索等领域的应用。工艺通过共混不同种类的聚丙烯均聚物或者共聚物以及抗氧化、抗紫外等助剂，使其粘度满足了纤维的要求；在共混改性过程中，通过挤出机搭配熔体过滤系统，进一步除去体系杂质，再通过调整工艺参数完成细旦及高强聚丙烯纤维的制备。',
      '项目是典型的"产-学-研-用"示范线，将建成1万吨级/年纤维级回收餐盒聚丙烯切片生产示范线、回收餐盒聚丙烯高强纤维生产示范线和1千吨级/年回收聚丙烯细旦纤维生产示范线。',
    ],
    reason: ['项目创新性地提出利用餐盒回收的聚丙烯材料通过共混改性制备成高价值细旦和高强纤维，应用于运动服饰和安全绳索等场景，从终端应用推动大规模回收餐盒聚丙烯的再生利用，将极大提升PP餐盒回料的价值空间。'],
    imgurl: 'https://img.meituan.net/gongyimobile/9bf5b35089beae1de3de7473b2299ab74652098.jpg',
    year: '2021',
  },
  {
    name: '废弃外卖快餐盒绿色循环与高质利用示范',
    organization: ['广东金发科技有限公司', '江苏金发再生资源有限公司'],
    introduction: [
      '项目建立"回收打包网点-分选回收工厂-高质化利用工厂-高端改性产品"的产业链模式，打造完整的塑料回收及再生利用系统。从源头形成完整的回收利用体系，减轻了末端处理压力，打通并整合上下游产业，实现资源的综合利用。',
      '项目还研制了特殊结构的高速自洁净技术，形成废弃塑料餐盒的洁净工艺及装备。开发了适合PP再生塑料加工的挤出系统、切粒系统、螺杆组合、熔体过滤系统和气味去除系统的塑料高质回收和再生利用示范生产线。',
      '项目将建成10000吨/年塑料餐盒再生处置示范线和1-2个塑料餐盒分拣中心。',
    ],
    reason: ['项目是国内首个万吨级别的塑料餐盒回收和再生利用示范线。针对废弃塑料餐盒的回收，打通并整合上下游产业，建立PP塑料的"回收到再生利用"的产业链模式，实现了资源的综合利用。'],
    imgurl: 'https://img.meituan.net/gongyimobile/e8b5890bde2dc05fca79689efa0463e75468199.jpg',
    year: '2021',
  },
];

export const projectData2023 = [
  {
    name: '高安全性无氟食品包装功能材料产业化示范',
    organization: ['浙江恒达新材料股份有限公司', '浙江恒川新材料有限公司', '鹤山市德柏纸袋包装品有限公司'],
    introduction: [
      '本项目主要提供一种造纸机内生产无氟防油纸的技术方案，通过造纸机内表面施胶微量功能性助剂，显著降低纸张表面能，使纸张具备优异防热油性能，同时保证纸张的多孔结构，从而保持外卖包装内容物食品口感。该产品为机内一次完成，无需后续加工工序，具备节能环保、生产效率高、可行性强的特点，且最终包装产品可加工性好、印刷效果及印刷油墨牢度佳。',
      '项目将完成无氟防油食品包装用纸的技术开发和无氟防油食品包装原纸的生态环境效益报告，交付2万吨/年的无氟食品包装用纸生产线，实现产品在外卖商家的实际应用，并形成使用案例报告。',
    ],
    reason: [
      '随着欧美国家相继出台"禁氟"法令，无氟防油纸是行业趋势，能够更好地提升外卖和外带场景下油性食品的安全性。相较现有无氟替代方案，本项目提供的造纸机内生产无氟防油纸的技术，旨在达到性能要求的前提下，减轻纸张克重和防油剂用量，实现纸张防油性与透气度的平衡，兼具提升食品安全性，保持外卖食品口感，减少包装用纸消耗的社会及环境效益。',
    ],
    imgurl: 'https://img.meituan.net/gongyimobile/4735f7a9feb0d147fc95b4cd62b2d06e205346.jpg',
    year: '2023',
  },
  {
    name: '废弃奶茶杯高值化再生价值链创新与示范',
    organization: ['南通睿科环保科技有限公司', '江西睿聚再生科技有限公司'],
    introduction: [
      '本项目旨在研发废弃奶茶杯高值化再生技术，并形成价值链创新与示范。通过对奶茶杯设计、结构材料、回收链路、消费习惯等现状的基础调研，研究奶茶杯再生过程中脱墨、去标签、提纯等关键技术问题，通过创新的技术方案向市场提供高纯净度、低气味、颜色浅、高安全性、绿色环保的奶茶杯再生PP塑料颗粒，并探索突破传统低端应用场景，将其扩展至中高端应用场景。',
      '项目将完成废弃奶茶杯高值化再生技术研发和奶茶杯品类前端生态设计建议报告，交付2000吨/年的奶茶杯再生产线，项目期间奶茶杯累计回收处理量达2000吨，生产1200吨产品颗粒，产品颗粒满足相关检测标准。',
    ],
    reason: [
      '奶茶是新兴且快速增长的外卖品类，但奶茶杯由于油墨、杯体结构等问题，缺乏良好再生场景，且目前奶茶杯混同餐盒回收（比例10-15%），还需单独分拣，增加回收成本，影响回收率提升。本项目拟研发的高效分拣设备和油墨去除工艺有助于提升奶茶杯的分拣效率和再生价值，提升奶茶杯PP颗粒的再生价值，从而引导前端回收率提升。此外，以高值化回收再生为目标导向，项目有望联动行业前端奶茶包装的生态设计，促进奶茶杯逐渐应用材质单一、减少印刷以及标签使用等绿色设计方案。',
    ],
    imgurl: 'https://img.meituan.net/gongyimobile/54b63d35fc8cbd9ad93810607261f5c23559223.jpg',
    year: '2023',
  },
  {
    name: '福州低值废塑料智能化分选中心',
    organization: ['厦门陆海环保股份有限公司'],
    introduction: [
      '本项目计划在福州市落成一座低值废塑料智能化分选中心。项目将以分选中心为载体、以先进分选工艺技术为支撑，实现含餐饮外卖包装在内的低值废塑料的规模化回收与精细化分选；同时融入再生资源网络，链接下游再生资源企业，以规模、品质稳定的再生资源销售支持项目的持续运营，最终打造成福州垃圾分类收运与再生资源回收"两网融合"的可持续发展模式。',
      '项目将完成具有自主知识产权的多模态一体化分选控制装备研发，交付具备1.8万吨/年分选产能的自动化分选产线，并结合福州"无废城市"建设和项目推进情况开展包含餐饮外卖包装分类投放内容的社区宣传活动。',
    ],
    reason: [
      '2022年12月，厦门陆海环保在厦门市落成全国首个低值可回收物分拣中心，实现了我国在低值可回收物规模化回收利用上的突破，而福州项目将探索在其他具有较好生活垃圾分类基础的城市开展低值可回收物规模化回收利用的模式可复制性。其中，涉及的核心技术创新为自研分选设备模组，有望显著降低项目运行成本，提升项目经济效益及模式的可推广性和可持续性。从而，有望在更大范围内推动餐饮外卖包装纳入社会化回收体系进行消纳处置，提升外卖包装回收和利用率。',
    ],
    imgurl: 'https://img.meituan.net/gongyimobile/c53997097653d31534a3f091028494e05905743.jpg',
    year: '2023',
  },
];

export const projectData = {
  2021: projectData2021,
  2023: projectData2023,
};
